import {Component, OnInit} from '@angular/core';
import {NavController, NavParams, ModalController, AlertController} from 'ionic-angular';
import {KeywordsService} from "../../providers/keywords-service";
import {KeywordsEditPage} from "../keywords-edit/keywords-edit";
import {KeywordsAddPage} from "../keywords-add/keywords-add";

/*
 Generated class for the KeywordsList page.

 Ionic pages and navigation.
 */
@Component({
  selector: 'page-keywords-list',
  templateUrl: 'keywords-list.html'
})
export class KeywordsListPage implements OnInit {
  keywords = [];

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public keywordsService: KeywordsService,
              private _modal: ModalController,
              private alertCtrl: AlertController) {
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad KeywordsListPage');
  }

  ngOnInit() {
    this.loadKeywords();
  }

  loadKeywords() {
    this.keywordsService.getKeywords().subscribe(
      (data) => {
        this.keywords = data;
      },
      err => console.log(err)
    )
  }

  editKeyword(id) {
    let myModal = this._modal.create(KeywordsEditPage, {id: id});
    myModal.onDidDismiss((data) => {
      this.updateKeyword(data);
    });
    myModal.present();
  }

  updateKeyword(keyword) {
    if (keyword) {
      if (keyword.tag === '') {
        keyword.tag = keyword.key;
      }
      this.keywordsService.updateKeyword(keyword).subscribe(
        (data) => {
          // console.log(data);
          this.keywordsService.saveKeywords().subscribe(
            () => this.loadKeywords(),
            err => console.log(err)
          );
        },
        err => console.log(err)
      )
    }
  }

  newKeyword() {
    let myModal = this._modal.create(KeywordsAddPage);
    myModal.onDidDismiss((data) => {
      this.createKeyword(data);
    });
    myModal.present();
  }

  createKeyword(keyword) {
    if (keyword) {
      if (keyword.tag === '') {
        keyword.tag = keyword.key;
      }
      this.keywordsService.createKeyword(keyword).subscribe(
        (data) => {
          // console.log(data);
          this.keywordsService.saveKeywords().subscribe(
            () => this.loadKeywords(),
            err => console.log(err)
          );

        },
        err => console.log(err)
      )
    }
  }

  deleteKeyword(id) {
    // event.stopPropagation();

    let confirm = this.alertCtrl.create({
      title: 'Sei sicuro?',
      message: 'Confermi l\'eliminazione della keyword ' + this.keywords[id].key + '?',
      buttons: [
        {
          text: 'Annulla',
          handler: () => {
            // console.log('Disagree clicked');
          }
        },
        {
          text: 'Elimina',
          handler: () => {
            // console.log('Agree clicked');
            this.keywordsService.deleteKeyword(id).subscribe(
              () => {
                this.keywordsService.saveKeywords().subscribe(
                  () => this.loadKeywords(),
                  err => console.log(err)
                );
              },
              err => console.log(err)
            )
          }
        }
      ]
    });
    confirm.present();

  }

  testCheckboxOpen;
  testCheckboxResult;
  enablings;

  manageAgencies() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Quali agenzie vuoi abilitare?');

    this.keywordsService.getAgencyEnablings().subscribe(
      data => {
        this.enablings = data;
        for (let a of data) {
          if (a.visible)
            alert.addInput({
              type: 'checkbox',
              label: a.name,
              value: a.name,
              checked: a.enabled
            });
        }
        alert.addButton('Cancel');
        alert.addButton({
          text: 'Okay',
          handler: data => {
            // console.log('Checkbox data:', data);
            this.testCheckboxOpen = false;
            this.testCheckboxResult = data;
            let result = [];
            for (let k of this.enablings) {
              if (data.indexOf(k.name) !== -1) {
                result.push(true);
              } else {
                result.push(false);
              }
            }

            this.keywordsService.saveAgencyEnablings(result).subscribe(
              (data) => {
                // console.log(data);
                this.keywordsService.saveKeywords().subscribe(
                  () => this.loadKeywords(),
                  err => console.log(err)
                );
              },
              err => console.log(err)
            )
          }
        });
        alert.present();
      }
    )

  }


}



// WEBPACK FOOTER //
// ./src/pages/keywords-list/keywords-list.ts